<template>
  <div class="conditions-shell">
    <section class="conditions-panel about-service">
      <header class="conditions-panel__hero fall">
        <div class="conditions-panel__heading">
          <p class="conditions-panel__eyebrow">Inscription examen</p>
          <h2 class="conditions-panel__title">
            Conditions d'inscription à l'examen {{ section }}
          </h2>
        </div>

        <div class="conditions-panel__intro">
          <p>
            Vérifiez les prérequis administratifs, le délai minimal d'accès à la
            formation et les points utiles avant de constituer votre dossier.
          </p>
        </div>
      </header>

      <div class="conditions-grid">
        <article
          v-for="card in cards"
          :key="card.id"
          class="conditions-card"
          :class="[`conditions-card--${card.tone}`, card.motion]"
        >
          <div class="conditions-card__top">
            <p class="conditions-card__kicker">{{ card.kicker }}</p>
            <span class="conditions-card__index">{{ card.index }}</span>
          </div>

          <div class="conditions-card__copy">
            <p class="conditions-card__label">{{ card.label }}</p>
            <h3>{{ card.title }}</h3>

            <ul class="conditions-card__list">
              <li v-for="item in card.items" :key="item">
                {{ item }}
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutService",
  props: {
    section: {
      type: String,
      required: true,
      default: "vtc",
    },
  },
  computed: {
    showsVtcSpecificNote() {
      return String(this.section || "")
        .toLowerCase()
        .includes("vtc");
    },
    cards() {
      const infoItems = [
        "Vous devez être en capacité physique de devenir chauffeur professionnel.",
      ];

      if (this.showsVtcSpecificNote) {
        infoItems.push(
          "Le casier judiciaire, la visite médicale VTC et le PSC1 VTC ne sont pas demandés lors de l'inscription à l'examen VTC."
        );
      }

      infoItems.push(
        "L'institut Taxi c'est 93% de réussite aux examens et plus de 600 avis sur google, rejoignez-nous !"
      );

      return [
        {
          id: "prerequisites",
          index: "01",
          kicker: "Avant dossier",
          label: "Les conditions",
          title: "Prérequis",
          tone: "sun",
          motion: "slide-left",
          items: [
            "Le candidat doit être détenteur d'une carte d'identité européenne valide ou avoir un titre de séjour lui permettant d'exercer en France.",
            "Le candidat doit être titulaire d'un permis B depuis au moins trois ans et non soumis à une période probatoire.",
          ],
        },
        {
          id: "timeline",
          index: "02",
          kicker: "Accès formation",
          label: "Le délai",
          title: "Modalité",
          tone: "paper",
          motion: "fall",
          items: ["Durée d'accès à la formation: 11 Jours minimum."],
        },
        {
          id: "good-to-know",
          index: "03",
          kicker: "À valider",
          label: "Infos utiles",
          title: "À savoir",
          tone: "night",
          motion: "slide-right",
          items: infoItems,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.conditions-shell {
  width: min(100%, 1280px);
  margin: clamp(54px, 7vw, 96px) auto;
  padding: 0 16px;
}

.conditions-panel {
  padding: clamp(26px, 4vw, 44px);
  border-radius: 34px;
  background: #ffffff;
  border: 1px solid rgba(0, 42, 84, 0.08);
  box-shadow: 0 22px 44px rgba(0, 42, 84, 0.08);
}

.conditions-panel__hero {
  display: grid;
  gap: 18px;
  margin-bottom: 24px;
}

.conditions-panel__heading {
  display: grid;
  gap: 12px;
}

.conditions-panel__eyebrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-height: 36px;
  margin: 0;
  padding: 0 16px;
  border-radius: 999px;
  background: $color-secondary;
  color: $color-primary;
  font-family: "adam";
  font-size: 0.76rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  box-shadow: 0 10px 20px rgba(254, 185, 20, 0.18);
}

.conditions-panel__title {
  margin: 0;
  color: $color-primary;
  font-size: clamp(2rem, 2vw + 1.35rem, 3.15rem);
  line-height: 1.04;
  text-wrap: balance;
}

.conditions-panel__intro {
  max-width: 560px;
  justify-self: end;
  padding: 18px 20px;
  border-radius: 24px;
  background: $color-primary;
  box-shadow: 0 18px 30px rgba(0, 42, 84, 0.18);

  & p {
    margin: 0;
    color: rgba(245, 236, 236, 0.92);
    font-size: 1rem;
    line-height: 1.6;
  }
}

.conditions-grid {
  display: grid;
  gap: 20px;
}

.conditions-card {
  min-height: 100%;
  padding: 24px;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  border: 1px solid rgba(0, 42, 84, 0.08);
  box-shadow: 0 16px 30px rgba(0, 42, 84, 0.08);
}

.conditions-card--sun {
  background: $color-secondary;
}

.conditions-card--paper {
  background: #ffffff;
}

.conditions-card--night {
  background: $color-primary;
  border-color: rgba(254, 185, 20, 0.2);
  box-shadow: 0 20px 34px rgba(0, 42, 84, 0.18);
}

.conditions-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
}

.conditions-card__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  background: $color-primary;
  color: $color-secondary;
  font-family: "Spartan", "Arial Black", Arial, sans-serif;
  font-weight: 700;
  font-size: 0.96rem;
  line-height: 1;
  box-shadow: 0 10px 18px rgba(0, 42, 84, 0.14);
}

.conditions-card--night .conditions-card__index {
  background: $color-secondary;
  color: $color-primary;
  box-shadow: 0 10px 18px rgba(254, 185, 20, 0.16);
}

.conditions-card__kicker {
  margin: 0;
  padding: 9px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  color: $color-primary;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  text-align: center;
}

.conditions-card--sun .conditions-card__kicker {
  background: rgba(0, 42, 84, 0.1);
}

.conditions-card--night .conditions-card__kicker {
  background: rgba(255, 255, 255, 0.1);
  color: $color-secondary;
}

.conditions-card__copy {
  display: grid;
  gap: 14px;

  & h3 {
    margin: 0;
    font-size: clamp(1.45rem, 1.1rem + 0.5vw, 1.9rem);
    line-height: 1.08;
    color: $color-primary;
  }
}

.conditions-card--night .conditions-card__copy h3 {
  color: $color-text-light;
}

.conditions-card__label {
  margin: 0;
  color: rgba(0, 42, 84, 0.62);
  font-family: "adam";
  font-size: 0.78rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.conditions-card--night .conditions-card__label {
  color: rgba(254, 185, 20, 0.76);
}

.conditions-card__list {
  list-style: none;
  display: grid;
  gap: 12px;
  margin: 0;
  padding: 0;

  & li {
    position: relative;
    padding-left: 18px;
    color: rgba(43, 43, 43, 0.92);
    font-size: 0.98rem;
    line-height: 1.58;

    &::before {
      content: "";
      position: absolute;
      top: 0.7rem;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $color-primary;
      box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.26);
    }
  }
}

.conditions-card--paper .conditions-card__list li::before {
  background: $color-primary;
  box-shadow: 0 0 0 4px rgba(0, 42, 84, 0.08);
}

.conditions-card--night .conditions-card__list li {
  color: rgba(245, 236, 236, 0.92);

  &::before {
    background: $color-secondary;
    box-shadow: 0 0 0 4px rgba(254, 185, 20, 0.14);
  }
}

@media screen and (min-width: 992px) {
  .conditions-shell {
    padding-inline: 22px;
  }

  .conditions-panel__hero {
    grid-template-columns: minmax(0, 1.18fr) minmax(320px, 0.82fr);
    align-items: end;
    gap: 24px;
    margin-bottom: 30px;
  }

  .conditions-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
  }

  .conditions-card {
    padding: 24px 24px 26px;
  }
}

@media screen and (max-width: 767px) {
  .conditions-shell {
    margin: 44px auto 68px;
    padding: 0 14px;
  }

  .conditions-panel {
    border-radius: 28px;
    padding: 22px 18px;
  }

  .conditions-panel__intro {
    justify-self: stretch;
    padding: 16px 16px 17px;
  }

  .conditions-card {
    border-radius: 24px;
    padding: 20px 18px;
  }

  .conditions-card__top {
    align-items: flex-start;
  }

  .conditions-card__kicker {
    text-align: right;
  }
}
</style>
